/* This example requires Tailwind CSS v2.0+ */
import withLayout from 'components/container-components/layout/withLayout';
import Link from 'next/link';
import { CommonRoutes } from 'routes';

export const Error404Component = () => {
  return (
    <div className="grid min-h-screen flex-1 place-items-center bg-white px-4 py-16 md:px-6 md:py-24 lg:px-8">
      <div className="mx-auto max-w-max">
        <div className="text-center md:flex md:text-left">
          <p className="text-4xl font-bold tracking-tight text-blue-600 md:text-5xl">404</p>
          <div className="md:ml-6">
            <div className="md:border-l md:border-gray-200 md:pl-6">
              <h1 className="text-4xl font-bold tracking-tight text-gray-900 md:text-5xl">Page not found</h1>
              <p className="mt-1 text-base text-gray-500">Please check the URL in the address bar and try again.</p>
            </div>
            <div className="mt-10 flex justify-center space-x-3 md:justify-start md:border-l md:border-transparent md:pl-6">
              <Link
                href={CommonRoutes.Dashboard}
                className="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-therablue focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Go back home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withLayout(Error404Component);
